'use client';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';

const ChatLayout = dynamic(
	() => import('../../../../../layouts/chat').then((mod) => mod.ChatLayout),
	{
		ssr: false,
	}
);
export default function Layout({ children }: React.PropsWithChildren) {
	return (
		<Suspense>
			<ChatLayout>{children}</ChatLayout>
		</Suspense>
	);
}
